import InsertDriveFileOutlined from '@mui/icons-material/InsertDriveFileOutlined';
import LanguageOutlined from '@mui/icons-material/LanguageOutlined';
import { IconFileCertificate } from 'components/icons';
// third-party
import { FormattedMessage } from 'react-intl';

// assets

import { NavItemType } from 'types';

const newCommunication: NavItemType = {
    id: 'new-communication',
    title: <FormattedMessage id="NUEVA_COMUNICACION" />,
    icon: LanguageOutlined,
    type: 'group',
    children: [
        {
            id: 'certified-communication',
            title: 'CERTIFICADA',
            type: 'item',
            url: '/certified-communication/send',
            icon: IconFileCertificate
        },
        {
            id: 'normal-communication',
            title: 'ESTANDAR',
            type: 'item',
            url: '/normal-communication/send',
            icon: InsertDriveFileOutlined
        }
    ]
};

export default newCommunication;
